var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"newMemberDetails"},[_c('iframe',{attrs:{"src":_vm.memberManageSrc}})])
}
var staticRenderFns = []

export { render, staticRenderFns }